// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"1ea105cc","205":"489f9ab0","410":"f34dc424","466":"48b95fb5","833":"c248caaa"}[chunkId] + ".chunk.js";
};